import React, { useCallback, useEffect } from "react";
import { PageDeleteConfirmationModalProps } from "../../types/modal";

export default function PageDeleteConfirmationModal(
  props: Readonly<PageDeleteConfirmationModalProps>
) {
  // Handle backdrop click
  const handleBackdropClick = useCallback((e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !props.isLoading) {
      props.onCancel();
    }
  }, [props]);

  // Handle escape key
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape' && !props.isLoading) {
      props.onCancel();
    }
  }, [props]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [handleKeyDown]);

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">
            Delete page {props.frameName}?
          </h2>
        </div>
        <div className="modal-body">
          <div className="form-wrapper">
            <p>
              Are you sure to delete page <b>{props.frameName}</b> from Figma
              Press?
              {props.isUpdatePending && (
                <em>
                  <br />
                  You will lose all your content updates of this page. This action
                  can't be undone!
                </em>
              )}
            </p>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.onCancel}
            disabled={props.isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={props.onDelete}
            disabled={props.isLoading}
          >
            {props.isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
